import { Breadcrumbs, Typography } from "@material-ui/core";
import resourceNames from "../../../common/data/resourceNames";
import { VehicleDto } from "../../../common/data/service-proxies";
import { VehicleNameBreadcrumbView } from "../../assets/maintenance-dashboard/VehicleBreadcrumb";
import styles from "./LocationLiveTrackTitle.module.css";

interface Props {
  isAnonymous: boolean;
  vehicle?: VehicleDto;
}

export const LocationLiveTrackTitle = ({ isAnonymous, vehicle }: Props) => {
  return isAnonymous ? (
    <Typography variant="h6">Live tracking / {vehicle?.name}</Typography>
  ) : (
    <Breadcrumbs className={styles.title}>
      <Typography variant="h6">Live tracking</Typography>
      <VehicleNameBreadcrumbView
        getBasePath={(x) =>
          x
            ? `/${resourceNames.LOCATIONS_LIVETRACK}/${x.id}`
            : `/${resourceNames.LOCATIONS_LIVETRACK}`
        }
        selectedVehicle={{ id: vehicle?.id }}
        getBackLink={() => "/"}
      >
        <Typography variant="h6">{vehicle?.name}</Typography>
      </VehicleNameBreadcrumbView>
    </Breadcrumbs>
  );
};
